<p-card>
    <div class="welcome">
        <!-- Columna izquierda: texto -->
        <div class="welcome-content">
            <p class="step">Paso 1</p>
            <h1>Empecemos por lo básico.</h1>
            <p class="description">
                Necesitaremos la información básica de tu propiedad. <br />
                Es bueno que tengas a la mano tu registro de propiedad.
            </p>
        </div>

        <!-- Columna derecha: imagen -->
        <div class="welcome-images">
            <img
                class="image image-1"
                src="assets/layout/images/home/1.png"
                alt="Paso 1: Imagen de ejemplo"
            />
        </div>
    </div>

    <!-- Barra de navegación inferior -->
    <app-page-navigation-bar
        [value]="5"
        [type]="'complete'"
        [previousPageURL]="'welcome'"
        [nextPageURL]="'segments'"
        [flowMode]="mode"
        [stepKey]="'start'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()">
    </app-page-navigation-bar>
</p-card>
